/**
 * TradeActionBadge Component
 *
 * Renders a colored badge for trade actions in rebalance/diff mode.
 * - BUY: Green badge
 * - SELL: Red badge
 * - HOLD: Gray badge
 * - null: Dash placeholder
 */

import React from "react";

export interface TradeActionBadgeProps {
  action: "BUY" | "SELL" | "HOLD" | null;
}

const TradeActionBadge: React.FC<TradeActionBadgeProps> = ({ action }) => {
  if (!action) {
    return <span className="text-gray-500">-</span>;
  }

  const badgeStyles: Record<"BUY" | "SELL" | "HOLD", string> = {
    BUY: "bg-green-500/20 text-green-400 border-green-500/30",
    SELL: "bg-red-500/20 text-red-400 border-red-500/30",
    HOLD: "bg-gray-500/20 text-gray-400 border-gray-500/30",
  };

  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 text-xs font-medium rounded border ${badgeStyles[action]}`}
    >
      {action}
    </span>
  );
};

export default TradeActionBadge;

